import React from 'react'
import { Row } from 'antd'
import {
  Image,
  MenuContainer,
  MenuItem,
  MenuText
} from '../../../../shared.style'
import FactoryIcon from '../../../../assets/icons/icon_factory.png'

const MenuFactoryAnnouncement = ({ history }) => {
  return (
    <MenuContainer>
      <Row justify="center">
        <MenuItem onClick={() => history.push(`/factory/announcement`)}>
          <Image src={FactoryIcon} alt="profile" />
        </MenuItem>
      </Row>
      <Row justify="center">
        <MenuText>ประกาศรับซื้อจากโรงงาน</MenuText>
      </Row>
    </MenuContainer>
  )
}

export default MenuFactoryAnnouncement



// WEBPACK FOOTER //
// ./src/pages/Account/components/MenuFactoryAnnouncement/index.js